import { render, staticRenderFns } from "./SortSwitch_manage.vue?vue&type=template&id=0a316f17&"
import script from "./SortSwitch_manage.vue?vue&type=script&lang=js&"
export * from "./SortSwitch_manage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports